export interface ArpFormatTile {
    id: string;
    order?: number;
    beginPosition?: number;
    endPosition?: number;
    width: number;
    type: string;
    name: string;
    text: string;
    active: string;
    optional: string;
}

export interface ArpFormatContainer {
    id: string;
    title: string;
    active: string;
}

export interface ArpFormatDesignerModel {
    id: number;
    title: string;
    type: string;
    name: string;
    delimiter: string;
    excludeHeaderRows: number;
    excludeFooterRows: number;
    itemAmountFormat: string;
    /** Maps to issueDateFormat on the DTO; the designer component uses this property name */
    effectiveDateFormat?: string;
    containers: ArpFormatContainer[];
    tiles: ArpFormatTile[];
    /** ARP-specific metadata preserved outside the designer */
    textQualifier?: string;
    issueDateFormat?: string;
    voidDateFormat?: string;
    accountTypeCheckingEquals?: string;
    accountTypeSavingsEquals?: string;
    voidYesIndicator?: string;
}

export interface ArpGlossaryTerm {
    name: string;
    text: string;
}

export interface ArpGlossaryGroup {
    title: string;
    label: string;
    id: string;
    terms: ArpGlossaryTerm[];
}

export const ARP_FIELD_DEFINITIONS: ReadonlyArray<{
    key: string;
    name: string;
    text: string;
    group: string;
    required: boolean;
}> = [
    {
        key: 'itemNumber',
        name: 'Check Number',
        text: 'The check number for the issued item',
        group: 'checkInformation',
        required: true,
    },
    {
        key: 'itemAmount',
        name: 'Check Amount',
        text: 'The dollar amount of the check',
        group: 'checkInformation',
        required: true,
    },
    {
        key: 'issueDate',
        name: 'Issue Date',
        text: 'The date the check was issued',
        group: 'checkInformation',
        required: false,
    },
    {
        key: 'payee',
        name: 'Payee',
        text: 'The name of the payee on the check',
        group: 'checkInformation',
        required: false,
    },
    {
        key: 'accountNumber',
        name: 'Account Number',
        text: 'The account number associated with the check',
        group: 'accountInformation',
        required: false,
    },
    {
        key: 'accountType',
        name: 'Account Type',
        text: 'The type of account (Checking or Savings)',
        group: 'accountInformation',
        required: false,
    },
    {
        key: 'voidDate',
        name: 'Void Date',
        text: 'The date the check was voided',
        group: 'voidInformation',
        required: false,
    },
    {
        key: 'voidIndicator',
        name: 'Void Indicator',
        text: 'Indicates whether the item is a void',
        group: 'voidInformation',
        required: false,
    },
];

export const ARP_GLOSSARY: ArpGlossaryGroup[] = [
    {
        title: 'Check Information',
        label: 'Check Information',
        id: 'checkInformation',
        terms: [
            { name: 'Check Number', text: 'The check number for the issued item' },
            { name: 'Check Amount', text: 'The dollar amount of the check' },
            { name: 'Issue Date', text: 'The date the check was issued' },
            { name: 'Payee', text: 'The name of the payee on the check' },
        ],
    },
    {
        title: 'Account Information',
        label: 'Account Information',
        id: 'accountInformation',
        terms: [
            { name: 'Account Number', text: 'The account number associated with the check' },
            { name: 'Account Type', text: 'The type of account (Checking or Savings)' },
        ],
    },
    {
        title: 'Void Information',
        label: 'Void Information',
        id: 'voidInformation',
        terms: [
            { name: 'Void Date', text: 'The date the check was voided' },
            { name: 'Void Indicator', text: 'Indicates whether the item is a void' },
        ],
    },
];
